import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
let k=1;
@Component({
  selector: 'app-create-single-request',
  templateUrl: './create-single-request.component.html',
  styleUrls: ['./create-single-request.component.scss'],
})
export class CreateSingleRequestComponent {
  brand;
  model;
  pay;
  colour;
  type;
  size;
  editShow:boolean=false;
  show:boolean=true;
  fDate;
  slotDate;
  slots;
  dateFormat;
  promotions;
  promoObj;
  couponId;
  discountCoupon;
  payTotal;
  popLoad:boolean=false;
  Id;
  // minDate = new Date();
  purchasedate:any;
  loader: boolean = true;
  active: boolean = true;
  editBool:boolean=false;
  activeInd: boolean = true;
  item:any;
  fontStyle;
  identificationNo;
  id;
  pic;
  cloneUsers:any=[];
  custName;
  category;
categoryName;
categoryId;
typeObj;
typeName;
typeId;
userId;
url;
typeObjAll;
Oid;users;
contactNbrMob;
itemCategoryId;
allServices:any=[];
services:any=[];
pacService:any=[];
serviceId;
serviceName;
startdate;
fdateCheck;
applicableDays;
applicableDaysName;
applicableDaysId;
allIndServices;
singleService;
daysObj=[{id:1,name:"Sunday"},
{id:2,name:"Monday"},
{id:3,name:"Tuesday"},
{id:4,name:"Wednesday"},
{id:5,name:"Thursday"},
{id:6,name:"Friday"},
{id:7,name:"Saturday"}];
dayType;
selectedDays:any=[];
date: any; 
buttonObj:any=[{name:"Individual House",flat:false,id:1},
{name:"Flat",flat:true,id:2}]
flatType = this.buttonObj[0].id;
appt:boolean = this.buttonObj[0].flat;
flatNo;
flatName;
custResItemObj:any=[];
custItemObj:any=[];
doorNbr;
custitem:any = [];
addItem:boolean=false;
custItemName;
custItemId;
street;
subsId;
subscription;
clicked:boolean=false;
head:boolean=false;
custReq:boolean=false;
addBtn:boolean=false;
serReq:boolean=false;
optionId;
area;
capacity;
categoryCode;
carService:boolean=false;
  pricing:boolean=false;
  homeCleaning:boolean=false;
  typeCode;
  acService;
  fridgeWashing;
  subType;
  optionName;
  subItemsType;
  itemTypeId;
  time = "Time";
  availableSlots=[];
  availSlot:boolean;
  slotClicked:boolean;
  openSlot:boolean = false;
  slot;
  makeName;
  makeId;
  modelName;
  modelId;
  makeObj:any=[];
  modelObj:any=[];
  constructor(private service: ApiService,public handler: HandlerService,public router: Router,
    public auth: AuthService,  public location: LocationService,   public bottomSheet: MatBottomSheet,private platform:Platform,
    private loc: Geolocation,
    private geoCoder:NativeGeocoder) { }

  ionViewWillEnter() {
    this.blockDate();
    this.Oid=localStorage.getItem('organizationId')
    this.dateFormat = this.auth.getDateformat();
    this.loader=true; 
    this.popLoad=false; 
    this.url = window.location.href;
    this.id = window.location.href.split('/').pop();
    this.subsId = sessionStorage.getItem('subscriptionId');
    this.itemTypeId = sessionStorage.getItem('itemType');
    this.itemCategory();     
    this.getUsers();  
    this.itemType();
    this.getSingleService();
    this.getdays(); 
    this.getPromotions();
    this.itemSubType();
 

this.loader=false;
          }

  itemCategory(){
    this.service.getOrgCategory().subscribe(res=>{
      this.category = res;
     
      if(this.url.includes('single-request-In')){
        if (this.category.length > 0) {
          this.category.map(res1 => {
            if (res1.id == this.subscription.categoryId) {
              this.categoryName = res1.name;
              this.categoryId = res1.id;
            } 
          })   
      }  
      }else{
        if (this.category.length > 0) {
          this.category.map(res1 => {
            if (res1.id == sessionStorage.getItem('itemCategoryId')) {
              this.categoryName = res1.name;
              this.categoryId = res1.id;
            }
          })   
      } 
      }
   
      })
  }

  itemType(){
    this.service.getItemType().subscribe(res=>{
      this.typeObjAll = res;   
    })
  }

  addCustItem(){
    if(this.custitem.length>0){
    this.custitem.map(res=>{
      if(res.clicked){
        res.clicked=false
       }
      })
    }
    this.addItem = true;
    this.custReq=false;
    this.serReq=true;
    this.custItemId = "";
  }

  getdays(){
    this.loader = true;
    this.service.getApplicableDays().subscribe((res:any)=>{
      this.applicableDays=res;
      this.loader = false;
    }) 
  }

  
  openBottomSheetDays(): void { 
    const dialogRef = this.bottomSheet.open(BottomSheet, {
     data:this.applicableDays,
   });
   dialogRef.afterDismissed().subscribe((res) => {
     this.applicableDaysName = res.name;
     this.applicableDaysId = res.id;
     });

 }


  getUsers(){  
    this.service.getUserById(this.id).subscribe((res:any) => {
      this.loader=false;
      this.users = res;  
      this.custName = this.users.firstName;
      this.contactNbrMob = this.users.contactNbrMob;
      if(this.users.addresses[0]){
      this.location.regionId=this.users.addresses[0].regionId;
      this.location.street=this.users.addresses[0].street;
      this.location.stateId=this.users.addresses[0].stateId;
      this.location.cityId=this.users.addresses[0].cityId;
      this.location.zipcode=this.users.addresses[0].zipcode; 
      this.appt=this.users.addresses[0].appt;
      if(!this.appt){
        this.flatType = 1;
      }else{
        this.flatType = 2;
      }
      this.doorNbr=this.users.addresses[0].doorNbr;
      this.flatName=this.users.addresses[0].flatName;
      this.flatNo=this.users.addresses[0].flatNo;
      }
      if(this.url.includes("single-booking")){                
        this.custItemId=sessionStorage.getItem('custItemId');
        this.custitem = this.users.custItems.filter(res=>{ return res.id == this.custItemId && res.make != "XXX"})  
        this.custitem.every(res=>Object.assign(res,{clicked:true}));
        this.head = true;
        this.addBtn = false;
        this.custReq=true;
        this.serReq=false;
        if(this.custitem[0]){
        this.location.regionId= this.custitem[0].regionId;
        this.location.street= this.custitem[0].street;
        this.location.stateId= this.custitem[0].stateId;
        this.location.cityId= this.custitem[0].cityId;
        this.location.zipcode= this.custitem[0].zipcode;
        this.appt= this.custitem[0].appt;
        if(!this.appt){
          this.flatType = 1;
        }else{
          this.flatType = 2;
        }
        this.doorNbr= this.custitem[0].doorNbr;
        this.flatName= this.custitem[0].flatName;
        this.flatNo= this.custitem[0].flatNo;
        }
        this.location.typeId = this.custitem[0].type;
      }
      if(this.url.includes('single-request') || this.url.includes('single-requests')){ 
       this.custItemObj=this.users.custItems;  
      }
       },err=>{
        this.handler.err(err)
        this.loader = false;
      }) 
   
  }

  onInput() {
    this.location.autoComplete();
  }

  sendId(data,id){
    data.clicked = ! data.clicked;
    this.custitem.map(res=>{if(id!=res.id){
      res.clicked=false;
    }
    })
    this.custItemId = id;
    let x=this.custitem.find(res=>res.clicked);
    if(!x){
      this.serviceName="";
      this.serviceId="";
      this.custItemId ="";
    }
    this.location.typeId = data.type;
    this.location.houseNbr=data.houseNbr;
    this.location.cityId=data.cityId;
    this.location.stateId=data.stateId;
    this.location.street=data.street;
    this.location.regionId=data.regionId;
    this.location.zipcode=data.zipcode;
    this.location.lat=data.lat;
    this.location.lon=data.lon;
    this.appt=data.appt;
    this.doorNbr=data.doorNbr;
    this.flatNo=data.flatNo;
    this.flatName=data.flatName;
    this.custReq=true;
    this.serReq=false;
  }

  createCustItem() {
    if(this.custItemId){
      this.create();
    }
  else{
    this.loader = true;
    if(!this.makeName){
      this.makeName="XXX";
    }
    if(!this.modelName){
      this.modelName="XXX";
    }
    if(!this.colour){
      this.colour="XXX";
    }
    if(!this.identificationNo){
      this.identificationNo="TN00A0000"
    }
    var post={
      "make": this.makeName,
      "model": this.modelName,
      "type": this.typeId,   
      "custName":this.custName,
      "contactNbrMob":this.contactNbrMob,
      "itemCategoryId":this.categoryId,
      "userId":this.id,
      "identificationNo":this.identificationNo,
      "activeInd": true,
      "colour":this.colour, 
      "appt":this.appt,
      "houseNbr": this.location.houseNbr,
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
      "subItemTypeId":this.optionId,
      "capacity":this.capacity,
      "area":this.area,
    } 
    if(!this.appt){
      Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
    }else{
      Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
    }
    this.service.custItem(post).subscribe(res=>{  
      this.custResItemObj = res; 
      this.custItemId=this.custResItemObj.id; 
      this. create();
      this.loader = false;   
   
    },
    err=>{
      this.loader=false;
      this.handler.err(err);
    })
  }
  
  }

    create() {
      this.loader = true;
      if(!this.Id){
        this.payTotal=this.location.markedPrice;
      }
       var post={   
        "custName":this.custName,
        "contactNbrMob":this.contactNbrMob,
        "custItemId":this.custItemId,
        "categoryId":this.categoryId,     
        "providerServiceId":this.serviceId,     
        "activeInd": true,
        "serviceProviderId":localStorage.getItem('organizationId'),
        "document":this.pic,
        "cost":this.location.markedPrice,
        "payTotal":this.payTotal,    
        "packageInd":false,
        "subscriptionInd":false,
        "requestorId":this.id,
        "apptDate": this.fDate,  
        "apptTime":this.time,
        "apptEndTime": this.slot.endTime,  
        "type":1,
        "status": 1,
        "requestDates": [
          {
            "apptDate": this.fDate,  
            "apptTime":this.time,
            "apptEndTime": this.slot.endTime,        
            "status": 1
          }],
        "address":{
          "houseNbr": this.location.houseNbr,
          "cityId": this.location.cityId,
          "stateId": this.location.stateId,
          "regionId":this.location.regionId,
          "zipcode":this.location.zipcode,
          "lat": this.location.lat,
          "lon": this.location.lon,
          "type": 1,
          "appt":this.appt
        }      
      
      } 
      if(!this.appt){
        Object.assign(post.address,{"doorNbr":this.doorNbr,"street": this.location.street})
      }else{
        Object.assign(post.address,{"flatNo":this.flatNo, "flatName":this.flatName,})
      }     
           this.service.createSingleReq(post).subscribe(res=>{     
          this.handler.res("Request Created Successfully");
        this.loader = false;
        this.brand=undefined;      
          this.router.navigate(['/newOndemand'])  
  
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
      })
    }
     
    getSingleService(){
      this.service.getAllItems().subscribe((res: any) => {
     this.allServices=res;
     console.log(res) 
     this.allIndServices= this.allServices.filter(res=>{return res.packageInd==false})
         if(this.categoryCode != "CAR"){
        this.allIndServices.map(res=>{
          res.subCost.map(res1=>{
            Object.assign(res,{itemTypeId:res1.itemTypeId})
          })
        })
         }
    })
 }

 cancel(){
  if(this.url.includes('single-requests')){
    this.router.navigate(['/monthly-Tracker']) 
  }else if(this.url.includes('single-request')){
    this.router.navigate(['/newOndemand'])
  }else if(this.url.includes('single-request-In')){
    this.router.navigate(['/monthly-Tracker'])
  }else{
    this.router.navigate(['viewItems/', this.id ])
  }
 }

 getAppt(id){
  this.appt = id;
}
    openBottomSheetService(): void {
      if(this.custItemId){
        if(this.categoryCode=="CAR"){
      this.singleService = this.allIndServices.filter(res=>res.itemCategoryId==this.categoryId)
        }else{
          this.singleService = this.allIndServices.filter(res=> res.itemCategoryId==this.categoryId && res.subCost[0].itemTypeId==this.typeId)
        }
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.singleService,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          this.serviceName=res.name;
          this.serviceId=res.id; 
          this.couponId=res.discAdId;
          this.location.subscriptionId = res.id;
          if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
            this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
           var data={
             "itemTypeId": this.location.typeId,
             "region": this.location.regionId,
             "serviceId":this.location.subscriptionId 
           }
           this.service.getCost(data).subscribe((res:any)=>{
             if(res!=null){
               this.location.markedPrice = res[0].cost;
               this.payTotal=this.location.markedPrice;
             }else{
               this.handler.error("Please Select Different Location");
               this.location.markedPrice = "";
             }
           }, err => {
             this.handler.err(err);
           })       
         }
        }
      });
    }
      else{  
        this.handler.error("Please Select Customer Item");
      }
    
    }

    openBottomSheetService1(): void {
      if(this.typeId)  {
        if(this.categoryCode=="CAR"){
          this.singleService = this.allIndServices.filter(res=>res.itemCategoryId==this.categoryId)
        }else{
          this.singleService = this.allIndServices.filter(res=>res.itemCategoryId==this.categoryId && res.itemTypeId==this.typeId)
        }
        console.log(this.singleService)
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.singleService,
      });
      dialogRef.afterDismissed().subscribe(res => {
        if(res){
          this.serviceName=res.name;
          this.serviceId=res.id; 
          this.location.subscriptionId = res.id;
          if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
            this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
           var data={
             "itemTypeId": this.location.typeId,
             "region": this.location.regionId,
             "serviceId":this.location.subscriptionId 
           }
           this.service.getCost(data).subscribe((res:any)=>{
             if(res!=null){
               console.log(res)
               this.location.markedPrice = res[0].cost;
               this.payTotal=this.location.markedPrice;
             }else{
               this.handler.error("Please Select Different Location");
               this.location.markedPrice = "";
             }
           }, err => {
             this.handler.err(err);
           })       
         }
        }
      });
      }else{
        this.handler.error("Please Add Your Item");
      }
    }
   
  
    ionViewWillLeave(){
      this.brand="";
      this.model="";
      this.custName="";
      this.contactNbrMob="";
      this.categoryName="";
      this.typeName="";
      this.serviceName="";
      this.identificationNo="";      
      this.location.markedPrice="";
      this.location.zipcode="";
      this.location.typeId="";
      this.location.subscriptionId = "";
      this.location.houseNbr="";
      this.location.street="";
      this.location.cityId="";
      this.location.stateId="";
      this.location.regionId="";
      this.location.zipcode="";
      this.location.pop=false;
      this.location.newSearch="";
      sessionStorage.removeItem('itemCategoryId')  
      sessionStorage.removeItem('custItemId')
      sessionStorage.removeItem('packageId')
    }

    userDetails(data){
      this.contactNbrMob =data.contactNbrMob;
      // this.userId = data.userId;
   
    }


  //  getUser(val) { 
  //   let x = val.length;
  //   if(x > 0){
  //     this.service.searchCustomers("CUST",val,this.Oid).subscribe((res: any) => {
  //       this.cloneUsers =JSON.parse(JSON.stringify(res)); 
  //     })
  //   }
  //   }

    openBottomSheet(): void {    
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.category,
      });
      dialogRef.afterDismissed().subscribe((res:any) => {
        if(res){
          this.categoryName = res.name;
          this.categoryId=res.id; 
          this.categoryCode=res.code;
          this.typeName="";
          this.serviceName=""; 
          this.typeId="";
          this.serviceId="";
          if(this.categoryCode=="CAR"){
            this.getCustMake();
          }
          if(this.url.includes("single-request") || this.url.includes('single-requests')){
            this.custitem=this.custItemObj.filter(res =>res.itemCategoryId == this.categoryId && res.make != "XXX" );
            this.custitem.every(res=>Object.assign(res,{clicked:false}));
            this.head=true;  
            this.addBtn=true;
           }  
          
           if(this.categoryCode=="CAR"){
             this.carService=true;
           }else{
             this.carService=false;
           }
           if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
             this.pricing=true;
             this.homeCleaning=true;
             
           } else{
             this.pricing=false;
             this.homeCleaning=false;
           }           
          }        
      });
    }
    openBottomSheetMake(): void {    
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.makeObj,
      });
      dialogRef.afterDismissed().subscribe((res:any) => {
        if(res){
          this.makeName = res.name;
          console.log(this.makeName)
          this.makeId=res.id; 
          if(this.makeId){
            this.getCustModel();
          }  
          }        
      });
    }
    openBottomSheetModel(): void {    
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.modelObj,
      });
      dialogRef.afterDismissed().subscribe((res:any) => {
        if(res){
          this.modelName = res.name;
          this.modelId=res.id;     
          }        
      });
    }

    openBottomSheet1(): void { 
      this.typeObj=this.typeObjAll.filter(res=> res.itemCategory==this.categoryId)   
        const dialogRef = this.bottomSheet.open(BottomSheet,{
          data: this.typeObj,
        });
        dialogRef.afterDismissed().subscribe((res:any) => {
          if(res){
            this.typeName = res.name;
            this.typeId=res.id;
            this.serviceName='';
            this.serviceId='';
            this.location.typeId=res.id;
            this.typeCode= res.code;
            if(this.typeCode=="AC"){
              this.fridgeWashing=true;
              this.acService=true;
            }   
            if(this.typeCode=="RF" || this.typeCode=="WM"){
              this.fridgeWashing=true;
            } 
            if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
              this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
                var data={
                  "itemTypeId": this.location.typeId,
                  "region": this.location.regionId,
                  "serviceId":this.location.subscriptionId 
                }
                this.service.getCost(data).subscribe((res:any)=>{
                  if(res!=null){
                    this.location.markedPrice = res[0].cost;
                    this.payTotal=this.location.markedPrice;
                  }else{
                    this.handler.error("Please Select Different Location");
                    this.location.markedPrice = "";
                  }
                }, err => {
                  this.handler.err(err);
                })
            }
          }
        });
      
    }

    switchDayType(val){
      let a=this.selectedDays.filter(res=>res.id==val);
      if(a.length>0){
        var b = a[0].id
      }
      if(b==undefined){
        let check=this.daysObj.find(res=>{return res.id==val})
        if(check){
          this.selectedDays.push({id:check.id,name:check.name})
        }
      }else{
        this.handler.res("Day Already Added")
      }
    }


    removeChip(i) {
      this.selectedDays.splice(i, 1);
    }


    
    handleFile(files) {
        var img = new Image();
        img.src = URL.createObjectURL(files[0]);
        img.onload = (data) => {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          this.pic = canvas.toDataURL('image/jpeg', 1.5);
        }
    }

    returnDate(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
     let month = data.getMonth() + 1;
     month = month < 10 ? '0' + month : month;
     let year = data.getFullYear();  
     return year + '-' + month + '-' + date;
   }

   returnDate1(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();  
   return date + '-' + month + '-' + year;
 }

   startDate(){
    this.fDate=this.returnDate(this.startdate);
    this.slotDate=this.returnDate1(this.startdate);
    this.time = "Time"
  }


  checkPreview(){
    this.openSlot = true;
    this.slotClicked =false;
    var post ={
      "targetCenterId": this.Oid,
      "targetSource": this.Oid,
      "schElements": [
          1
      ],
      "requestDate": this.slotDate,
      "status": [
          "SlotsAvailable"
      ],
      "independentEntities": true,
      "slotDuration": 15
  }
    this.service.getTimeSlots(this.slotDate,post).subscribe((res: any) => {
      if (res){
        this.availableSlots = res;
        this.availSlot = true;
        this.slotClicked = true;
      }else{
         this.handler.res("No Available Slots");
         this.availSlot = false;
         this.slotClicked = true;
      }
      
    })
  }

  setTime(data){
    this.time = data.startTime;
    this.slot = data;
    this.slotClicked = false;
    this.openSlot = false;
  }


    blockDate(){
      // Block From Date
      var someDate = new Date();
      var numberOfFromDaysToAdd = 0;
      someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd); 
      var dd = someDate.getDate();
      var mm = someDate.getMonth() + 1;
      var month = mm-1;
      var y = someDate.getFullYear();
      this.fdateCheck = new Date(y, month, dd)
    
    }

  
    getPromotions(){
      this.service.getServiceCoupon(this.Oid).subscribe(res=>{
        this.promotions = res;
      })
    }
       
         
    openBottomSheetDiscount(): void {
      this.promoObj = this.promotions.filter(res=>{ return res.id == this.couponId});
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.promoObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.discountCoupon = res.name;
        this.Id=res.id;
        this.getpayTotal();
      });
    }

    getpayTotal(){
      this.loader = true;
      var post={
        "cost":this.location.markedPrice,
        "discountCoupon":this.Id
      }
      this.service.getPayTotal(post).subscribe((res:any)=>{
      if(res){     
        this.payTotal = res.payTotal;
        this.loader = false;
      }     
      
      })
    }

    editCost(){
      this.show=false;
      this.editShow=true;
    
    }

    popClose(){
      this.location.pop=false;
      this.location.newSearch="";
      this.location.dummy = false;
    }
    openBottomSheetsubType(): void{ 
      this.subItemsType=this.subType.filter(res=> res.itemTypeId==this.typeId)
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data:this.subItemsType,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.optionName = res.name;
        this.optionId = res.id; 
        });
     }

    itemSubType(){
      this.service.getSubItemType().subscribe(res=>{
        this.subType=res;
       
      })
    }
    openLocation(){
      this.location.lat="";
      this.location.lon="";
       this.location.zipcode="";
       this.location.street="";
       this.location.stateId="";
       this.location.cityId="";
       this.location.regionId="";
      this.setLoc();  
      this.location.pop = false;
    }
    
    setLoc(){
      if(this.platform.ANDROID || this.platform.IOS){
          let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
        this.loc.getCurrentPosition().then(res => {
          this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
              let x: any = result;
              localStorage.setItem('location', JSON.stringify(x));
              let loc;
              loc=JSON.parse(localStorage.getItem('location'));
              this.location.lat=loc[0].latitude;
              this.location.lon=loc[0].longitude;
               this.location.zipcode=loc[0].postalCode;
               this.location.street=loc[0].thoroughfare;
               this.location.stateId=loc[0].administrativeArea;
               this.location.cityId=loc[0].locality;    
               this.location.regionId=loc[0].subLocality;       
          })        
      })
   }   
  }
  getCustMake(){
    this.modelName = "" ;
    this.modelId="";
    this.service.getMake(this.categoryId).subscribe((res:any)=>{
      if(res){
        this.makeObj = res;
        console.log(this.makeObj)
      }
    },err=>{
      this.handler.err(err)
    })
  }


  getCustModel(){
    this.popLoad=true;
    this.service.getModel(this.categoryId,this.makeId).subscribe((res:any)=>{
    this.modelObj = res;    
    this.popLoad =false;
    },
    err=>{
         this.handler.err(err);
  
    })
  }

}

